import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here
import Config from "../../Config.jsx";

import Localization from "../../Localization.jsx"

import {
  Icon,
  Tooltip,
  IconButton,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  CardActions,
  Typography,
  Divider,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';

import {
  blue,
  green,
  amber,
  red,
} from '@material-ui/core/colors'

const styles = {
  card: {
    minHeight: 420,
  },
  media: {
    height: 240,
  },
  actions: {
    display: 'flex',
  },
};

class LocaleListView extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  overviewLocaleClicked(index) {
    let id = this.props.parent.state.data[index].id;
    this.props.parent.overviewLocale(id);
  }

  editLocaleClicked(index) {
    let id = this.props.parent.state.data[index].id;
    this.props.parent.editLocaleByLocaleId(id);
  }

  infoLocaleClicked(index) {
    let id = this.props.parent.state.data[index].id;
    this.props.parent.showLocaleInfo(id);
  }

  retrieveAnswerClicked(index) {
    let id = this.props.parent.state.data[index].id;
    this.props.parent.retrieveAnswerByLocaleId(id);
  }

  retrieveHeatmapClicked(index) {
    console.log("retrieveHeatmapClicked");
    let id = this.props.parent.state.data[index].id;
    this.props.parent.retrieveHeatmapByLocaleId(id);
  }

  deleteLocaleClicked(id) {
    this.props.parent.deleteLocale(id);
  }

  previousPageClicked() {
    this.props.parent.previousPage();
  }

  nextPageClicked() {
    this.props.parent.nextPage();
  }

  pageChanged(e) {
    this.props.parent.changePage(e.target.value);
  }

  pageNavigator() {
    let pages = [];
    for (let i = 0; i < this.props.parent.state.totalPage; i++) {
      pages.push(i);
    }
    return [
      <div key="page" style={{padding:'0 12px 0 0', display:'inline-block'}}>{Localization.strings.PAGE}</div>,
      <FormControl key="currentPage" margin='dense'>
        <Select
          value={this.props.parent.state.currentPage}
          onChange={this.pageChanged}
        >
          {
            pages.map( (page, i) => {
              return (
                <MenuItem key={i} value={i}>{i+1}</MenuItem>
              )
            })
          }
        </Select>
      </FormControl>,
      <Tooltip key="previousPage"
        title={Localization.strings.PREVIOUS_PAGE}
        placement="bottom"
      >
        <span>
          <IconButton
            onClick={this.previousPageClicked}
            disabled={this.props.parent.state.currentPage <= 0}
          >
            <Icon>keyboard_arrow_left</Icon>
          </IconButton>
        </span>
      </Tooltip>,
      <Tooltip key="nextPage"
        title={Localization.strings.NEXT_PAGE}
        placement="bottom"
      >
        <span>
          <IconButton
            onClick={this.nextPageClicked}
            disabled={this.props.parent.state.currentPage + 1 >= this.props.parent.state.totalPage}
          >
            <Icon>keyboard_arrow_right</Icon>
          </IconButton>
        </span>
      </Tooltip>
    ];
  }

  render() {
    let isAdminUser = this.props.root.isAdminUser();
    let hasResearchAccess = this.props.root.hasResearchAccess();
    return (
      <div>
        <If condition={this.props.parent.state.data.length == 0}>
          <Then>
            <div style={{padding:"8px 0 0 24px", display:'inline-block'}}>
              <Card>
                <CardContent>
                  {Localization.strings.LOCALE_SEARCH_RESULT_NONE}
                </CardContent>
              </Card>
            </div>
          </Then>
          <Else>
            <If condition={this.props.parent.state.totalPage > 1}>
              <Then>
                <div style={{padding:"0 0 0 24px"}}>
                  {this.pageNavigator()}
                </div>
              </Then>
            </If>
            <Grid container style={{padding: '0 16px 0 16px'}}>
              {this.props.parent.state.data.map( (row, i) => {
                let editLocaleEnabled = (isAdminUser || (this.props.root.getSameSchoolEdit() == 1 && row['school_id'] == this.props.root.getMySchoolId()) || this.props.root.getOriginalUserId() == row['user_id']) && this.props.root.getAccountDisabled() != 1;
                let qaStateColor = blue[500];
                let qaState = row['qa_state'];
                if (qaState == 1) {
                  qaStateColor = green[500];
                }
                else if (qaState == 2) {
                  qaStateColor = amber[500];
                }
                else if (qaState == 3) {
                  qaStateColor = red[500];
                }

                return (
                  <Grid item key={i} xs={12} sm={6} md={4} lg={3} xl={2} style={{padding: 8}}>
                    <Card style={styles.card}>
                      <CardActionArea
                        disabled={!editLocaleEnabled}
                        onClick={()=>this.overviewLocaleClicked(i)}
                      >
                        <CardMedia
                          style={styles.media}
                          image={ Config.BASE_PATH() + row['file_tn_path'] }
                        />
                      </CardActionArea>
                      <CardContent>
                        <Typography gutterBottom variant="h5">
                          {row['locale_name']}
                        </Typography>
                        <Typography component="p" gutterBottom>
                          <If condition={row['description'].length > 30}>
                           <Then>
                             <ExpansionPanel elevation={0} >
                               <ExpansionPanelSummary expandIcon={<Icon>keyboard_arrow_down</Icon>} style={{padding:"0 1px 0 0"}}>
                                 {row['description'].substring(0, 30) + " ..."}
                               </ExpansionPanelSummary>
                               <ExpansionPanelDetails >
                                 {row['description']}
                               </ExpansionPanelDetails>
                             </ExpansionPanel>
                           </Then>
                           <Else>
                            <ExpansionPanelSummary style={{pointerEvents:"none",padding:"0 1px 0 0"}}>
                                {row['description']}
                            </ExpansionPanelSummary>
                           </Else>
                         </If>
                        </Typography>
                        <Divider style={{margin:"4px 0 4px 0"}}/>
                        <div>
                          <Typography gutterBottom>
                            <If condition={this.props.parent.state.isViewPublic}>
                              <Then>
                                {Localization.strings.getLanguage() === "en" && row['school_name_eng'] !== "" ? row['school_name_eng'] : row['school_name']}
                                <br/>
                              </Then>
                            </If>
                            {isAdminUser? row['id'] + " - " : ""}
                            {row['user_display_name']}
                          </Typography>
                          <Typography variant="caption">
                            {Localization.strings.UPDATED}: {row['date_update']}
                            <br/>
                            {Localization.strings.CREATED}: {row['date_created']}
                          </Typography>
                        </div>
                      </CardContent>
                      <CardActions style={styles.actions} disableSpacing>
                        <Tooltip
                          title={Localization.strings.EDIT_STAGES}
                          placement="bottom"
                        >
                          <span>
                            <IconButton onClick={()=>this.editLocaleClicked(i)} disabled={!editLocaleEnabled}>
                              <Icon>edit</Icon>
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip
                          title={Localization.strings.VIEW_EDIT_DETAILS}
                          placement="bottom"
                        >
                          <span>
                            <IconButton onClick={()=>this.infoLocaleClicked(i)} disabled={!editLocaleEnabled}>
                              <Icon>info</Icon>
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip
                          title={Localization.strings.RETRIEVE_ANSWERS}
                          placement="bottom"
                        >
                          <span>
                            <IconButton onClick={()=>this.retrieveAnswerClicked(i)}>
                              <Icon>assessment</Icon>
                            </IconButton>
                          </span>
                        </Tooltip>
                        <If condition={hasResearchAccess}>
                          <Then>
                            <Tooltip
                              title={Localization.strings.RETRIEVE_HEATMAP}
                              placement="bottom"
                            >
                              <span>
                                <IconButton onClick={()=>this.retrieveHeatmapClicked(i)}>
                                  <Icon>lens_blur</Icon>
                                </IconButton>
                              </span>
                            </Tooltip>
                          </Then>
                        </If>
                        <Tooltip
                          title={Localization.strings.DELETE}
                          placement="bottom"
                        >
                          <span>
                            <IconButton onClick={()=>this.deleteLocaleClicked(row['id'])} disabled={!editLocaleEnabled}>
                              <Icon>delete</Icon>
                            </IconButton>
                          </span>
                        </Tooltip>
                      </CardActions>
                      <If condition={isAdminUser}>
                        <Then>
                          <div style={{backgroundColor:qaStateColor, padding:'4px 0 0 0'}}></div>
                        </Then>
                      </If>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
            <If condition={this.props.parent.state.totalPage > 1}>
              <Then>
                <div style={{padding:"0 0 0 24px"}}>
                  {this.pageNavigator()}
                </div>
              </Then>
            </If>
          </Else>
        </If>
      </div>
    )
  }
}

export default LocaleListView;
